import { Maybe, Operation } from '../../../__generated__/globalTypes'

import getContactsIdsString from '../GetContactsIds.graphql'

export type GetContactsIdsData = {
  paginatedContacts: {
    allContacts: {
      id: string
    }[]
  }
}

export type GetContactsIdsVariables = {
  search?: Maybe<string>
  showSecondaryContacts?: Maybe<boolean>
}

export type GetContactsIds = Operation<
  GetContactsIdsData,
  GetContactsIdsVariables
>

export const GetContactsIds = ({
  search,
  showSecondaryContacts,
}: GetContactsIdsVariables = {}): GetContactsIds => ({
  query: getContactsIdsString,
  variables: {
    search,
    showSecondaryContacts,
  },
})
